import React from "react";
import {
  serviceCaller,
  ServiceCallerProps,
  ModalProps,
} from "../../composition";
import withStyles from "isomorphic-style-loader/withStyles";
import s from "./styles.scss";

interface Props extends ServiceCallerProps, ModalProps {
  title: string;
  mediaUrl: string;
  description: string;
}

class Tutorial extends React.PureComponent<Props> {
  render() {
    const title = this.props.title;
    const videoUrl = this.props.mediaUrl;
    const description = this.props.description;

    return (
      <div>
        <div className={s.videoContainer}>
          <iframe
            src={
              "https://player.vimeo.com/video/" +
              videoUrl.substr(8, videoUrl.length) +
              "?title=0&byline=0&portrait=0&badge=0&muted=0&pip=0"
            }
            width="438"
            height="438"
            frameBorder="0"
            allowFullScreen
          />
        </div>
        <h4 className={s.videoTitle}>{title}</h4>
        <p className={s.videoDescription}>{description}</p>
      </div>
    );
  }
}

export default serviceCaller(withStyles(s)(Tutorial));
